import { render, staticRenderFns } from "./integralGoodsInfo.vue?vue&type=template&id=82616b5c&scoped=true&"
import script from "./integralGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./integralGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./integralGoodsInfo.vue?vue&type=style&index=0&id=82616b5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82616b5c",
  null
  
)

export default component.exports